import { FEATURE_FLAG_NAMES, isFeatureEnabled, } from '@thoughtspot/feature-service';
import { emptyFormState, LLM_FORM_ERRORS, PROVIDER_CONFIG, } from './llm-form-constants';
export const isLlmFormValid = (llmFormData) => {
    const newErrors = { ...emptyFormState };
    let isValid = true;
    if (llmFormData.usecustomaccount) {
        const provider = llmFormData.provider;
        const fieldsToValidate = PROVIDER_CONFIG[provider]?.requiredFields || [];
        fieldsToValidate.forEach((field) => {
            newErrors[field] = '';
            if (!llmFormData[field]?.trim()) {
                newErrors[field] = LLM_FORM_ERRORS[field];
                isValid = false;
            }
        });
    }
    return { isValid, formErrors: newErrors };
};
export const getIsNewLlmConfig = () => {
    const isNewLlmConfig = isFeatureEnabled(FEATURE_FLAG_NAMES.IS_NEW_LLM_CONFIGURATION);
    return isNewLlmConfig;
};
export const getLlmNamingConvection = () => {
    const llmNamingConvection = new Map();
    llmNamingConvection.set('Azure OpenAI', 'AZURE_OPENAI');
    llmNamingConvection.set('Snowflake Mistral', 'SNOWFLAKE_MISTRAL');
    llmNamingConvection.set('Google Gemini', 'GOOGLE_GEMINI');
    return llmNamingConvection;
};
//# sourceMappingURL=llm-form-utils.js.map